// extracted by mini-css-extract-plugin
export default {"FAQ":"styles_FAQ__d1huW","container":"styles_container__5tWFh","Question":"styles_Question__evxtY"};